module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetHigh.4b4dc51.webp";